<template>
	<lcsj-dialog v-model="showDialog" ref="selectSupply" title="选择供应商" width="80%" append-to-body @close="closeDialog" cancel-text="取消" confirm-text="确认" :confirm-loading="isSubmitting" @confirm="submitSelectSupply">
		<div>
			<lcsj-filter :show-search="false" @search="inputChange()">
			<template #query>
				<el-button size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
				<el-button size="small" icon="el-icon-refresh" @click="clearAll">重置</el-button>
			</template>
			<template #actions></template>
			<el-form-item label="供应商名称：">
					<el-input clearable v-model="formInline.name" size="small" placeholder="请输入供应商名称" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
				<el-form-item label="电话：">
					<el-input clearable v-model="formInline.contactPhone" size="small" placeholder="请输入电话" @keyup.enter.native="inputChange"></el-input>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe highlight @get-data="getListData" @current-change="handleSupplyCurrentChange"></STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</div>
		
	</lcsj-dialog>
</template>

<script>
import { getSupplyInfoPageList } from "@/api/baseDataApi.js";
export default {
	data() {
		return {
		isSubmitting: false, // 提交中（防重复提交）
			showDialog: false,
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				name: "",
				contactUser: "",
				contactPhone: ""
			},
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					prop: "name",
					label: "供应商名称",
					isKeep: true,
					minWidth: "120"
				},
				{
					prop: "contactUser",
					label: "联系人",
					minWidth: "100"
				},
				{
					prop: "contactPhone",
					label: "联系电话",
					minWidth: "120"
				},
				{
					prop: "address",
					label: "地址"
				},
				{
					prop: "creator",
					label: "创建人",
					minWidth: "120"
				},
				{
					prop: "createTime",
					label: "创建时间",
					minWidth: "120"
				},
				{
					prop: "editor",
					label: "维护人",
					minWidth: "120"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					minWidth: "120"
				}
			]
		};
	},
	// 注册组件
	components: {},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
	},
	computed: {},
	methods: {
		//展示弹窗
		showSelectCustomerDialog() {
			this.showDialog = true;
			this.search();
		},
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		// 表格选中事件
		handleSupplyCurrentChange(currentRow) {
			if (currentRow == null || currentRow == undefined || currentRow == "") {
				return;
			}
			let keyId = currentRow.keyId;
			this.selectionKeyId = keyId;
		},
		changePages() {},
		// 获取列表
		getListData() {
			this.loading = true;
			getSupplyInfoPageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		// 重置
		clearAll() {
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.search();
		},
		inputChange(val) {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		//选中后提交
		submitSelectSupply() {
			if (this.selectionKeyId == "") {
				this.$message.error("请选择供应商");
				return;
			}
			this.$parent.chooseSupply(this.selectionKeyId);
			this.closeDialog();
		},
		// 关闭
		closeDialog() {
			this.showDialog = false;
			this.selectionKeyId = "";
			this.$data.formInline = this.$options.data.call(this).formInline;
			this.listData = [];
			this.selection = [];
		}
	}
};
</script>

<style scoped>

</style>
